var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("subir-documento-adjunto"),
      _vm._v(" "),
      _c("VerDocumento"),
      _vm._v(" "),
      _c(
        "h3",
        { staticClass: "primary--text" },
        [
          _c("v-icon", { attrs: { color: "primary" } }, [_vm._v("backup")]),
          _vm._v(" Documentos adjuntos")
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.table,
                  loading: _vm.loading
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function(props) {
                      return [
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.index + 1))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(_vm._s(props.item.nombre_documento))
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.doc_requisitos.length > 0
                                  ? _vm
                                      .$moment(
                                        props.item.doc_requisitos[0]
                                          .fecha_emision
                                      )
                                      .format("DD/MM/YYYY")
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.doc_requisitos.length > 0
                                  ? props.item.doc_requisitos[0].nro_certificado
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                props.item.doc_requisitos.length > 0
                                  ? props.item.doc_requisitos[0].observacion
                                  : ""
                              ) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-center" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.parametro_tipo.valor) +
                              "\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-center" },
                          [
                            props.item.doc_requisitos.length == 0
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", color: "primary" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.adjuntarArchivo(props.item)
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("attach_file")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.doc_requisitos.length > 0 &&
                            _vm.estado == 1
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      slot: "activator",
                                      icon: "",
                                      color: "error"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.borrar(
                                          props.item.doc_requisitos[0].id
                                        )
                                      }
                                    },
                                    slot: "activator"
                                  },
                                  [_c("v-icon", [_vm._v("delete")])],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            props.item.doc_requisitos.length > 0
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "", color: "info" },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.verDocumento(
                                          props.item.doc_requisitos[0]
                                        )
                                      }
                                    }
                                  },
                                  [_c("v-icon", [_vm._v("visibility")])],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-aec67692", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aec67692","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/components/DocumentosAdjuntos.vue
// module id = null
// module chunks = 